import React from 'react';

/**
 * OptimizedImage component with WebP fallbacks for better Core Web Vitals
 * Provides next-gen image format support with graceful fallbacks
 * For now, uses standard img tag until WebP/AVIF versions are available
 */
const OptimizedImage = ({ 
  src, 
  alt, 
  className = '', 
  loading = 'lazy',
  width,
  height,
  sizes,
  ...props 
}) => {
  // For now, use standard img tag with optimizations
  // TODO: Implement WebP/AVIF when optimized images are available
  return (
    <img 
      src={src} 
      alt={alt} 
      className={className}
      loading={loading}
      width={width}
      height={height}
      sizes={sizes}
      {...props}
    />
  );
};

export default OptimizedImage;
